module.exports = __webpack_public_path__ + "img/category-fishing-game.71296f5b.png";